export default __webpack_public_path__ + "static/media/MAIZ.0c43bbe6.png";